import React from 'react';
import useAuthGuard from '../hooks/useAuthGuard';
import Layout from '../components/Layout';

function InformationDetail() {
    useAuthGuard();

    return (
        <Layout>

InformationDetail

        </Layout>
    );
}

export default InformationDetail;
